import type { PropsWithChildren } from "react";
import { Button } from "react-aria-components";
import { formatIsoDate } from "src/utils/dateTime";
import { tw } from "src/design-system/tw";
import { FormattedDepartureDate } from "../../../FormattedDepartureDate/FormattedDepartureDate";

type DateInputProps = PropsWithChildren<{
  isOpen: boolean;
  blink: boolean;
  text?: string;
  date?: Date;
  label: string;
  buttonProps?: React.ComponentProps<typeof Button>;
}>;

export default function DateInput({
  isOpen,
  text,
  date,
  buttonProps,
  blink,
  label,
}: DateInputProps) {
  return (
    <Button
      className={tw(
        "relative flex w-27 cursor-pointer flex-wrap items-center rounded-full bg-neutral-700 px-4 py-2 text-left text-body-lg text-text-secondary hover:bg-neutral-800 focus-visible:outline-1",
        isOpen && "bg-neutral-900",
        !!date && "text-text-primary",
      )}
      {...buttonProps}
    >
      <label className="mb-0.5 w-full text-label-sm font-medium text-text-primary">
        {label}
      </label>
      {date ? (
        <FormattedDepartureDate
          className="mt-0.5"
          dateOptions={{
            day: "2-digit",
            month: "short",
          }}
          departureDate={formatIsoDate(date)}
        />
      ) : (
        <span className="overflow-hidden text-nowrap overflow-ellipsis">
          {text}
        </span>
      )}
      {blink && (
        <span className="relative ml-2 h-2 w-2 rounded-full bg-fill-brand">
          <span className="absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-full bg-fill-brand motion-safe:animate-ping"></span>
        </span>
      )}
    </Button>
  );
}
